import { apiFetch } from "./client";

export interface SupportSession {
  enabled: boolean;
  ice_servers: RTCIceServer[];
  ring_timeout_s: number;
  supervisore_nome: string | null;
  supervisore_online: boolean;
}

export function getSupportSession(): Promise<SupportSession> {
  return apiFetch<SupportSession>("/support/session");
}

/** URL del WS di signaling, derivato dall'origin corrente (stesso host del portale). */
export function supportWsUrl(): string {
  const proto = window.location.protocol === "https:" ? "wss:" : "ws:";
  return `${proto}//${window.location.host}/ws/support`;
}
